import { NgModule } from '@angular/core';
import { ExpandableComponent } from './expandable/expandable.component';
import { FooterComponent } from './footer/footer.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { CategoryMenuComponent } from './category-menu/category-menu.component';
import { FormsModule } from '@angular/forms';
import { OptimizedImageDirective } from './optimized-image.directive';
@NgModule({
	declarations: [ExpandableComponent,FooterComponent, HeaderComponent, CategoryMenuComponent, OptimizedImageDirective],
	imports: [IonicModule,CommonModule,RouterModule,FormsModule],
	exports: [ExpandableComponent,FooterComponent, HeaderComponent, CategoryMenuComponent, OptimizedImageDirective]
})
export class ComponentsModule {}
